export enum Roles {
  SUBMIT_VIEW_TEST_SLIP = 'Submit & View Test Slips',
  REVIEW_TEST_SLIP = 'Review Test Slips',
  ADMIN_GUEST = 'Admin ( Guest)',
  ADMIN = 'Admin',
  BROWSE_HANDBOOK = 'Browse Handbook',
  ADMIN_STANDARDS = 'Admin (Standards Mgmt)',
  TRAINER = "SMTH Trainer",
  TRAINEE = "SMTH Trainee",
  READ_ONLY = "Read Only (Default)",
}
